/**  @jsx jsx */
import { memo, useMemo } from 'react';
import { jsx } from '@emotion/react';
import PrimitiveSVGIcon from '@atlaskit/icon/svg';
function getIcon(isIndeterminate, isChecked) {
  if (isIndeterminate) {
    return jsx("rect", {
      fill: "inherit",
      x: "8",
      y: "11",
      width: "8",
      height: "2",
      rx: "1"
    });
  }
  if (isChecked) {
    return jsx("path", {
      d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
      fill: "inherit"
    });
  }

  // No icon
  return null;
}

/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */
var CheckboxIcon = /*#__PURE__*/memo(function (_ref) {
  var size = _ref.size,
    isIndeterminate = _ref.isIndeterminate,
    isChecked = _ref.isChecked;
  var icon = useMemo(function () {
    return getIcon(isIndeterminate, isChecked);
  }, [isIndeterminate, isChecked]);
  return jsx(PrimitiveSVGIcon, {
    label: "",
    size: size,
    primaryColor: "var(--checkbox-background-color)",
    secondaryColor: "var(--checkbox-tick-color)"
  }, jsx("g", {
    fillRule: "evenodd"
  }, jsx("rect", {
    fill: "currentColor",
    x: "6",
    y: "6",
    width: "12",
    height: "12",
    rx: "2"
  }), icon));
});
export default CheckboxIcon;